import React from "react";
import S from "./Modal.styled";
const Modal = ({ isShown, hide, modalContent, headerText, handleDelete, handleCancel, }) => {
    if (!isShown)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Backdrop, null),
        React.createElement(S.Wrapper, null,
            React.createElement(S.StyledModal, null,
                React.createElement(S.Header, null,
                    React.createElement(S.HeaderText, null, headerText),
                    React.createElement(S.CloseButton, { onClick: hide }, "X")),
                React.createElement(S.Content, null,
                    React.createElement(S.InnerText, null,
                        " ",
                        modalContent),
                    React.createElement(S.ModalFooter, null,
                        React.createElement(S.RemoveButton, { onClick: handleDelete }, "Ok"),
                        React.createElement(S.CancelButton, { onClick: handleCancel }, "Cancel")))))));
};
export default Modal;
//# sourceMappingURL=Modal.js.map